import React from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import CircularProgress from '@material-ui/core/CircularProgress'

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  padding: 0px 16px 64px 16px;
`

const TableTitle = styled.h2`
  padding-bottom: 16px;
  margin: 0 auto;
  color: #555;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 500;
`

const TableContainer = styled.div`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  height: 700px;
  margin: 0 auto;
  overflow: auto;
  position: relative;
`

const Table = styled.table`
  background: #FFF;
  border-spacing: 0px;
  width: 100%;
`

const TableHead = styled.thead`
  color: #FFF;
`

const TableBody = styled.tbody`
`

const TableHeadRow = styled.tr`
`

const TableBodyRow = styled.tr`
  cursor: pointer;
  &:hover {
    background: #f2f2f2;
  }
`

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${props => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${props => (props.bigWidth) ? '160px' : '100px' };
  padding: 8px;
  position: sticky;
  top: 0;
  z-index: 30;
`

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${props => props.number ? props.theme.font.primary : props.theme.font.secondary};
  padding: 4px;
  text-align: center;
`

const HqChallengeTable = (props) => {
  const handleClick = (challenge) => {
    props.history.push('/dashboard/hq-challenge/' + challenge.id)
  }

  return props.hqChallengesState !== 2 ? (
    <Container>
      <CircularProgress size={32} />
    </Container>
  ) : (
    <Container>
      <TableTitle>Found {props.hqChallenges.length} HQ challenge(s)</TableTitle>
      <TableContainer>
        <Table>
          <TableHead>
            <TableHeadRow>
              <HeadCell>Challenge ID</HeadCell>
              <HeadCell>Name</HeadCell>
              <HeadCell>Description</HeadCell>
              <HeadCell># of your clients participanting</HeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
          {props.hqChallenges.map((entry, index) => {
            return (
              <TableBodyRow key={entry.id} onClick={() => handleClick(entry)}>
                <DataCell>{entry.id}</DataCell>
                <DataCell>{entry.name}</DataCell>
                <DataCell>{entry.description}</DataCell>
                <DataCell>{entry.client_id_list.length}</DataCell>
              </TableBodyRow>
            )
          })}
          </TableBody>
        </Table>
      </TableContainer>
    </Container>
  )
}

export default withRouter(HqChallengeTable)